import { CheckoutTableProps } from '../../../pages/Purchase/LongSteel/CheckoutMVP/CheckoutTable';
import { EMeasureUnit } from '../../commomTypes';

// Action Types
export enum Types {
  REQUEST_ORDER_SIMULATE = '/entry-order/order-simulate/REQUEST_ORDER_SIMULATE',
  REQUEST_ORDER_SIMULATE_SUCCESS = '/entry-order/order-simulate/REQUEST_ORDER_SIMULATE_SUCCESS',
  REQUEST_ORDER_SIMULATE_FAILURE = '/entry-order/order-simulate/REQUEST_ORDER_SIMULATE_FAILURE',
  CLEAN_ORDER_SIMULATE = '/entry-order/order-simulate/CLEAN_ORDER_SIMULATE',

  REQUEST_FINALIZE_SALE = '/entry-order/order-simulate/REQUEST_FINALIZE_SALE',
  FINALIZE_SALE_SUCCESS = '/entry-order/order-simulate/FINALIZE_SALE_SUCCESS',
  FINALIZE_SALE_FAILURE = '/entry-order/order-simulate/FINALIZE_SALE_FAILURE',
  RESET_SALE_FAILURE_CONFIRMATION = '/entry-order/order-simulate/RESET_SALE_FAILURE_CONFIRMATION',

  UPDATE_CUSTOMER_ORDER_ID = '/entry-order/order-simulate/UPDATE_CUSTOMER_ORDER_ID',
  UPDATE_CUSTOMER_PURCHASE_ID = '/entry-order/order-simulate/UPDATE_CUSTOMER_PURCHASE_ID',

  UPDATE_CHECKOUT_STATE_LOCAL_STORAGE = '/entry-order/order-simulate/UPDATE_CHECKOUT_STATE_LOCAL_STORAGE',
  UPDATE_PDF_STATE_LOCAL_STORAGE = '/entry-order/order-simulate/UPDATE_PDF_STATE_LOCAL_STORAGE',
  UPDATE_CHECKOUT_STATE = '/entry-order/order-simulate/UPDATE_CHECKOUT_STATE'
}

export interface IItemOrderSimulate {
  item_id_gerdau: string;
  material: string;
  unityMeasure: string;
  requiredDate: string;
  quantity: string;
  term: string;
  benefit: string;
  plant: number;
  salesGroup: string;
  salesOffice: string;
  salesOrg: string;
  distrChannel: number;
  activitySector: string;
  industrialType: string;
  consumptionOrder: string;
  price_agreement_date_gerdau: string;
}

export interface IItemParamOrderSimulate {
  name: string;
  item_id_gerdau: string;
  material: string;
  unityMeasure: string;
  requiredDate: string;
  quantity: string;
  term: string;
  item_category?: string;
  benefit: string;
  plant: number;
  salesGroup: string;
  salesOffice: string;
  salesOrg: string;
  distrChannel: number;
  activitySector: string;
  industrialType: string;
  consumptionOrder: string;
  price_agreement_date_gerdau: string;
  sku?: string;
  customerPurchaseItem?: string;
  paymentTerms: IPaymentTermMvp[];
  measureUnits: IMeasureUnit[];
  fiscalBenefits: IFiscalBenefitMvp[] | undefined;
  description: string; // do industrialType
  cartOptions?: IMeasureUnit[];
}
export interface IItemSaleInfoMvp {
  sku?: string;
  activitySector?: string;
  benefit?: string;
  distrChannel?: number;
  industrialType?: string | undefined;
  material?: string;
  plant?: number;
  quantity?: string;
  requiredDate?: string;
  salesGroup?: string;
  salesOffice?: string;
  salesOrg?: string;
  term?: string;
  unityMeasure?: EMeasureUnit | string;
  multipleQuantity?: string;
  minimumQuantity?: string;
  customerPurchaseItem?: string;
  consumptionOrder?: string | undefined;
  description?: string;
  totalWeightInTon: string;
}

export interface IDestinationMvp {
  paymentTerms: IPaymentTermMvp[];
  measureUnits: IMeasureUnit[];
  fiscalBenefits: IFiscalBenefitMvp[] | undefined;
  company: string;
  description: string;
  distributionChannel: string;
  division: string;
  minimumDate: string;
  multiPlant: boolean;
  plant: string;
  plantDescription: string;
  salesGroup: string;
  salesOffice: string;
  salesOrg: string;
  condGroup: string;
}
export interface IDataOrderSimulate {
  items: IItemParamOrderSimulate[];
  soldTo: string;
  shipTo: string;
  cartNumber: string;
  purchaseNumber: string;
  createdAt: string;
  updatedAt: string;
}

export interface IPayloadOrderSimulate {
  items: IItemOrderSimulate[];
  soldTo: string;
  shipTo: string;
  cartNumber: string;
  purchaseNumber: string;
}

export interface IParamsOrderSimulate {
  soldTo: string;
  shipTo: string;
  cartNumber: string;
  purchaseNumber: string;
}

export interface ISapPriceOrderSimulate {
  price_with_discount_total: string;
  icms_st?: string;
  icms?: string;
  ipi?: string;
  fcp?: string;
  pis?: string;
  cofins?: string;
  iss?: string;
  ibs?: string;
  difal?: string;
}

interface IHeaderSAP {
  shipto: string;
  soldto: string;
  purch_no_c: string;
  sales_org: string;
  distr_chan: string;
  division: string;
  sales_grp: string;
  sales_off: string;
}

interface IItemSAP {
  material: string;
  disp_date: string;
  beneficio: string;
  beneficiocode: string;
  plant: string;
}

interface ISAPFields {
  o_header_sap: IHeaderSAP;
  o_item_sap: IItemSAP;
  o_price_sap: ISapPriceOrderSimulate;
}

interface IExtensionAttributesOrderSimulate {
  item_id_gerdau: string;
  measure_unity_gerdau: string;
  expected_date_gerdau: string;
  destination_gerdau: string;
  payment_type_gerdau: string;
  payment_terms_description_gerdau?: string;
  tax_benefit_gerdau: string;
  has_agreed_price_gerdau: boolean;
  price_agreement_date_gerdau: string;
  sap_fields: ISAPFields;
}

export interface IFiscalBenefitMvp {
  code: string;
  description: string;
}

export interface IPaymentTermMvp {
  description: string;
  term: string;
}

export interface IMeasureUnit {
  convMeasureKg: string; // "1"
  convMeasureTo: string; // "0,001"
  measure: EMeasureUnit; // "KG"
  minimumQuantity: string; // "0.000"
  multiple: string; // "1000.000"
}

export interface ICustomerIdParams {
  customerId: string;
  itemId: string;
  salesOrderId: string;
  index: number;
}

export interface ISalesParams {
  data: IItemSaleInfoMvp[];
  emitterId: string;
  receiverId: string;
  customerOrder: string;
  cartNumber: string;
  isNewCheckoutFlow?: boolean;
  taxes?: string;
}

export interface IItemResponseOrderSimulate {
  item_id: number | undefined;
  sku: string;
  qty: string;
  quoteId: string;
  extension_attributes: IExtensionAttributesOrderSimulate;
}

export interface IOrder {
  order: IItemResponseOrderSimulate[];
}

export interface IDataResponseOrderSimulate {
  orders: IOrder[];
  o_price_sap_totals: IPriceSapTotals;
}

export interface IPriceSapTotals {
  price_with_discount_total: string;
  icms_st: string;
  icms: string;
  ipi: string;
  fcp: string;
  pis: string;
  cofins: string;
  price_net: string;
  difal?: string;
}

export interface ICheckoutResponse {
  orders: IOrder[];
  o_price_sap_totals: IPriceSapTotals;
  cartId: string;
  cartCreatedIn: string;
  cartUpdatedIn: string;
}

export interface IOrderSimulateState {
  loading: boolean;
  error: boolean;
  params: IDataOrderSimulate | null;
  data: ICheckoutResponse | null;
  ordersTable: CheckoutTableProps[];
  ordersSent: string[];
  errorOrdersSent: boolean;
  errorMessage?: string;
  loadingOrdersSent: boolean;
  orderConfirmationRequested: boolean;
  pdf: {
    text: string | null;
    table: string | null;
  };
  orderCompleted?: boolean;
  favoritedSkus?: string[];
}

export interface ITaxesCalculateItem {
  itemWeb: string;
  activitySector: string;
  benefFisc: string;
  consumptionOrder: string;
  distrChannel: number;
  industrialType: string;
  item_id_gerdau: string;
  material: string;
  plant: number;
  price_agreement_date_gerdau: string;
  quantity: string;
  requiredDate: string;
  salesGroup: string;
  salesOffice: string;
  salesOrg: string;
  term: string;
  unityMeasure: string;
  benefit: string;
  isAgreementPricing: string;
}

export interface ITaxesCalculatePayload {
  shipTo: string;
  soldTo: string;
  purchaseNumber: string;
  cartNumber: string;
  items: ITaxesCalculateItem[];
}

export interface ITaxesCalculateResponse {
  icms: number;
  cofins: number;
  pis: number;
  difal: number;
  fcp: number;
  st: number;
  ipi: number;
  total_include_tax: number;
  total_exclude_tax: number;
}

// Estimated Date API Types
export interface IEstimatedDateItem {
  item_web: string;
  unityMeasure: string;
  quantity: string;
  requiredDate: string;
  material: string;
  plant: string;
  salesOffice: string;
  salesGroup: string;
  distrChannel: string;
  salesOrg: string;
  activitySector: string;
  term: string;
}

export interface IEstimatedDatePayload {
  soldTo: string;
  shipTo: string;
  items: IEstimatedDateItem[];
}

export interface IEstimatedDateOrderItem {
  item: string;
  product: string;
  plant: string;
  requestedDate: string;
  confirmedDate: string;
  requestedQuantity: string;
  confirmedQuantity: string;
  unitOfMeasure: string;
  scheduleLine: string;
}

export interface IEstimatedDateResponse {
  orderItems: IEstimatedDateOrderItem[];
}
